import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

const CustomsTooltip = withStyles((theme) => ({
  tooltip: {
    color: theme.colors.primary,
    boxShadow: theme.shadows[1],
    backgroundColor: theme.palette.common.white,
  },
}))(Tooltip)

const LightTooltip = (props) => {
  const { children, ...rest } = props

  return <CustomsTooltip {...rest}>{children}</CustomsTooltip>
}

LightTooltip.propTypes = {
  children: PropTypes.node,
}
export default LightTooltip
